import { useState } from 'react'
import { useForm } from 'react-hook-form'

import MarketTradeInput from '../MarketTradeInput'
import MarketTradePercentages from '../MarketTradePercentages'
import MarketTradeInfo from '../MarketTradeInfo'
import MarketTradeButton from '../MarketTradeButton'

const MarketTradeSell = () => {
  const { handleSubmit, register } = useForm({
    defaultValues: {
      price: '',
      amount: '',
    },
  })

  const [percentage, setPercentage] = useState()

  const handleFormSubmit = () => {}

  return (
    <form
      onSubmit={handleSubmit(handleFormSubmit)}
      className="flex-1 pl-[15px] border-l-[#e0e3eb] border-l-[1px]"
    >
      <div className="w-full flex flex-col gap-y-[14px] mb-[14px]">
        <MarketTradeInput placeholder="Price" currency="BTC" {...register('price')} />

        <MarketTradeInput placeholder="Amount" currency="ETH" {...register('amount')} />
      </div>

      <MarketTradePercentages
        activePercentage={percentage}
        onPercentageChange={setPercentage}
        activeColor="bg-[#ef5350]"
      />

      <MarketTradeInfo />

      <MarketTradeButton background="bg-[#ff231f]" shadow="shadow-market-trade-sell">
        SELL
      </MarketTradeButton>
    </form>
  )
}

export default MarketTradeSell
